import React from 'react';

import { 
	func, 
	number
} from 'prop-types';
import lineHeight from 'line-height';

export const adjustRowSize = ({target,maxRows,minRows}) => {
	const textareaLineHeight = lineHeight(target);
	const previousRows = target.rows;
	target.rows = minRows;
	const currentRows = ~~(target.scrollHeight / textareaLineHeight);

	if (currentRows === previousRows) {
		target.rows = currentRows;
	}
	
	if (currentRows >= maxRows) {
		target.rows = maxRows;
		target.scrollTop = target.scrollHeight;
	}
	return currentRows < maxRows ? currentRows : maxRows;
};

export default class RowCounter extends React.PureComponent {
    static propTypes = {
    	render : func.isRequired,
    	maxRows : number,
    	minRows : number,
    	onChange : func.isRequired
    }
	
    constructor(props){
    	super(props);
    	const {maxRows=5,minRows=2} = props;
    	this.textInput = React.createRef();
    	this.state = {
    		maxRows,
    		minRows,
    		currentRows : minRows,
    	};
    }
	
	componentDidMount = ()=>{
		const { maxRows, minRows } = this.state;
		if(this.textInput.current){
			this.setState({
				currentRows: adjustRowSize({target:this.textInput.current,maxRows,minRows}),
			});
		}
	}
	
	onChange = (event) => {
		const { maxRows, minRows } = this.state;
		const { onChange } = this.props;
		this.setState({
			currentRows: adjustRowSize({target:event.target,maxRows,minRows}),
		});
		onChange && onChange(event);
	};

	render(){
		const {render,maxRows,minRows,onChange,...other} = this.props;
    	return render({
			ref : this.textInput,
			rows : this.state.currentRows,
    		onChange : this.onChange,
    	},other);
	}
}